import React from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import Modal from '../../../../components/Modal';
import { useDeviceWarningsStore } from './state/use-device-warnings-store';

const DeviceWarningsModal = () => {
  const { isOpen, deviceId, serialNumber, close, warningsByDeviceId } = useDeviceWarningsStore();
  const warnings = warningsByDeviceId[deviceId] ?? [];

  return (
    <Modal
      showModal={isOpen}
      setShowModal={close}
      title="Предупреждения"
      showSave={false}
      classWidth="relative w-11/12 max-w-md my-6 mx-3">
      <div className="space-y-3 text-gray-700">
        {serialNumber && <p className="text-sm text-gray-500">Контроллер «{serialNumber}»</p>}

        {warnings.map((warning) => (
          <div key={warning.risk_number} className="flex items-start gap-x-3 p-4 rounded-2xl bg-red-50">
            <WarningAmberRoundedIcon className="text-red-500 shrink-0" />
            <div className="space-y-1 min-w-0">
              <p className="font-semibold text-gray-800">{warning.title}</p>
              {warning.body && <p className="text-sm text-gray-600 whitespace-pre-wrap">{warning.body}</p>}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default DeviceWarningsModal;
